var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "signature-container" },
    [
      _vm.active
        ? _c(
            "div",
            {
              class: {
                "alert alert-success": _vm.status == "success",
                "alert alert-danger": _vm.status == "danger",
              },
              attrs: { role: "alert", id: "signature-alert" },
            },
            [_vm._v("\n      " + _vm._s(_vm.messageText) + "\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.emailEdit
        ? _c("div", [
            _vm._m(0),
            _vm._v(" "),
            _c("div", [_vm._v("Current Email: " + _vm._s(_vm.currentEmail))]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.changedEmail,
                  expression: "changedEmail",
                },
              ],
              staticClass: "email-input",
              attrs: { type: "text" },
              domProps: { value: _vm.changedEmail },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.changedEmail = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                on: {
                  click: function ($event) {
                    return _vm.changeEmail()
                  },
                },
              },
              [_vm._v("Change")]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.documents, function (document, documentIndex) {
        return _c(
          "table",
          {
            staticClass: "mt-5 fl-table",
            class: { deactive: document.cancelled_at },
          },
          [
            _c("thead", [
              _c("tr", [
                _c(
                  "th",
                  {
                    staticStyle: {
                      "background-color": "#333",
                      "text-align": "left",
                    },
                    attrs: { colspan: "8" },
                  },
                  [
                    document.file
                      ? _c(
                          "a",
                          {
                            staticStyle: { color: "white" },
                            attrs: {
                              target: "_blank",
                              href: `/api/signatures/download/${document.request_id}`,
                            },
                          },
                          [_vm._v(_vm._s(document.file.file_name))]
                        )
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    staticStyle: {
                      "background-color": "#333",
                      "text-align": "left",
                    },
                    attrs: { colspan: "1" },
                  },
                  [
                    _c(
                      "a",
                      {
                        class: {
                          deactive:
                            document.status === "cancelled" ||
                            document.status === "signed",
                        },
                        staticStyle: { color: "white", float: "right" },
                        attrs: {
                          id: "document-cancel-button",
                          href: "javascript:;",
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.cancel(document)
                          },
                        },
                      },
                      [_vm._v("Cancel")]
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _vm._m(1, true),
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(
                document.signatories,
                function (signatory, signatoryIndex) {
                  return _c(
                    "tr",
                    { key: signatoryIndex, staticStyle: { padding: "5px" } },
                    [
                      _c("td", [_vm._v(_vm._s(signatory.name))]),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            color: "blue",
                            cursor: "pointer",
                            "text-decoration": "underline",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.openChange(
                                    signatory,
                                    signatoryIndex,
                                    document
                                  )
                                },
                              },
                            },
                            [_vm._v(_vm._s(signatory.email))]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(signatory.status))]),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "max-width": "200px",
                            "overflow-x": "scroll",
                          },
                        },
                        [_vm._v(_vm._s(signatory.data))]
                      ),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(_vm._s(_vm.formatDate(signatory.viewed_at))),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(_vm._s(_vm.formatDate(signatory.reminded_at))),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(_vm._s(_vm.formatDate(signatory.signed_at))),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        signatory.stop_reminders == 1
                          ? _c("span", [
                              _vm._v("\n\t\t\t\t\t\t\tCancelled\n\t\t\t\t\t\t"),
                            ])
                          : _c(
                              "a",
                              {
                                class: {
                                  deactive:
                                    signatory.status === "cancelled" ||
                                    signatory.signed_at ||
                                    signatory.status === "signed",
                                },
                                attrs: { href: "javascript:;" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.stopAutoRemind(
                                      signatory,
                                      document
                                    )
                                  },
                                },
                              },
                              [_vm._v("Cancel")]
                            ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        document.article.granular_status_id !== "022_010"
                          ? _c(
                              "a",
                              {
                                class: {
                                  deactive:
                                    signatory.status === "cancelled" ||
                                    signatory.signed_at ||
                                    _vm.request,
                                },
                                attrs: { href: "javascript:;" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.remind(signatory, document)
                                  },
                                },
                              },
                              [_vm._v("Remind")]
                            )
                          : _vm._e(),
                      ]),
                    ]
                  )
                }
              ),
              0
            ),
          ]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("strong", [
        _vm._v(
          "Changing the email will send a new email to the new address and make the document inaccessible from the previous address."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("th", [_vm._v("Name")]),
      _vm._v(" "),
      _c("th", [_vm._v("Email")]),
      _vm._v(" "),
      _c("th", [_vm._v("Status")]),
      _vm._v(" "),
      _c("th", [_vm._v("Conflict")]),
      _vm._v(" "),
      _c("th", [_vm._v("Viewed At")]),
      _vm._v(" "),
      _c("th", [_vm._v("Reminded At")]),
      _vm._v(" "),
      _c("th", [_vm._v("Signed At")]),
      _vm._v(" "),
      _c("th", [_vm._v("Cancel Auto Remind")]),
      _vm._v(" "),
      _c("th", [_vm._v("Action")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }